export const businessCategories = [
  "Automobile",
  "FMCG",
  "Retail & Whole Sale",
  "NBFC",
  "Finance & Investment",
  "Restaurant & Cafe",
  "Hotels & lodging",
  "Electronics & Electricals",
  "Beauty, Health & Wellness",
  "Food & Beverages",
  "Business & Auxiliary Services",
  "Education",
  "Travel & Tourism",
  "Sports, Games & Entertainment",
  "Pharma & Health Care",
  "IT & BPO",
  "Personal Care & Fashion",
  "Advertisement & Media",
  "Web & App Design",
  "Construction & Interior",
  "Real Estate",
];

export const entityType = [
  "Sole Proprietorship",
  "Partnership",
  "HUF",
  "Co- Operative Society / Trust",
  "LLP",
  "Private Limited Company",
  "Public Limited Company",
  "One Person Company",
];

export const countries = [
  { country: "India", code: "+91", flag: "IN" },
  { country: "Afghanistan", code: "+93", flag: "AF" },
  { country: "Albania", code: "+355", flag: "AL" },
  { country: "Algeria", code: "+213", flag: "DZ" },
  { country: "Andorra", code: "+376", flag: "AD" },
  { country: "Angola", code: "+244", flag: "AO" },
  { country: "Argentina", code: "+54", flag: "AR" },
  { country: "Armenia", code: "+374", flag: "AM" },
  { country: "Australia", code: "+61", flag: "AU" },
  { country: "Austria", code: "+43", flag: "AT" },
  { country: "Azerbaijan", code: "+994", flag: "AZ" },
  { country: "Bahamas", code: "+1-242", flag: "BS" },
  { country: "Bahrain", code: "+973", flag: "BH" },
  { country: "Bangladesh", code: "+880", flag: "BD" },
  { country: "Belarus", code: "+375", flag: "BY" },
  { country: "Belgium", code: "+32", flag: "BE" },
  { country: "Brazil", code: "+55", flag: "BR" },
  { country: "Canada", code: "+1", flag: "CA" },
  { country: "China", code: "+86", flag: "CN" },
  { country: "Denmark", code: "+45", flag: "DK" },
  { country: "Egypt", code: "+20", flag: "EG" },
  { country: "Finland", code: "+358", flag: "FI" },
  { country: "France", code: "+33", flag: "FR" },
  { country: "Germany", code: "+49", flag: "DE" },
  { country: "Greece", code: "+30", flag: "GR" },

  { country: "Indonesia", code: "+62", flag: "ID" },
  { country: "Iran", code: "+98", flag: "IR" },
  { country: "Ireland", code: "+353", flag: "IE" },
  { country: "Italy", code: "+39", flag: "IT" },
  { country: "Japan", code: "+81", flag: "JP" },
  { country: "Kenya", code: "+254", flag: "KE" },
  { country: "Malaysia", code: "+60", flag: "MY" },
  { country: "Mexico", code: "+52", flag: "MX" },
  { country: "Netherlands", code: "+31", flag: "NL" },
  { country: "New Zealand", code: "+64", flag: "NZ" },
  { country: "Nigeria", code: "+234", flag: "NG" },
  { country: "Norway", code: "+47", flag: "NO" },
  { country: "Pakistan", code: "+92", flag: "PK" },
  { country: "Philippines", code: "+63", flag: "PH" },
  { country: "Poland", code: "+48", flag: "PL" },
  { country: "Portugal", code: "+351", flag: "PT" },
  { country: "Russia", code: "+7", flag: "RU" },
  { country: "Saudi Arabia", code: "+966", flag: "SA" },
  { country: "South Africa", code: "+27", flag: "ZA" },
  { country: "South Korea", code: "+82", flag: "KR" },
  { country: "Spain", code: "+34", flag: "ES" },
  { country: "Sri Lanka", code: "+94", flag: "LK" },
  { country: "Sweden", code: "+46", flag: "SE" },
  { country: "Switzerland", code: "+41", flag: "CH" },
  { country: "Thailand", code: "+66", flag: "TH" },
  { country: "Turkey", code: "+90", flag: "TR" },
  { country: "Ukraine", code: "+380", flag: "UR" },
  { country: "United Arab Emirates", code: "+971", flag: "AE" },
  { country: "United Kingdom", code: "+44", flag: "GB" },
  { country: "United States", code: "+1", flag: "US" },
  { country: "Vietnam", code: "+84", flag: "BN" },
  { country: "Zimbabwe", code: "+263", flag: "ZW" },
];